import { useEffect, useState } from 'react';
import styles from './TravelDocuments.module.scss';
import AccommodationDetails from './AccommodationDetails/AccommodationDetails';
import RoomDetails from './RoomDetails/RoomDetails';
import TransportDetails from './TransportDetails/TransportDetails';
import VoucherDownload from './VoucherDownload/VoucherDownload';
import AccommodationTickets from './AccommodationTickets/AccommodationTickets';

function TravelDocuments(props) {
  const {
    tabID,
    accommodationVouchers,
    transport,
    orderStatus,
    isParisPackage,
    orderId,
    balance,
    onSwitchToRecommendations,
    recommedations,
  } = props;
  const [roomSummary, setRoomSummary] = useState(false);
  const [accommodationDetails, setAccommodationDetails] = useState(false);
  const [transportDetails, setTransportDetails] = useState(false);
  const [accommodationTickets, setAccommodationTickets] = useState(false);
  const [voucherDownload, setVoucherDownload] = useState(false);
  useEffect(() => {
    if (
      accommodationVouchers
      && accommodationVouchers[0]
      && accommodationVouchers[0].accommodationDetails.rooms
      && Object.keys(accommodationVouchers[0].accommodationDetails.rooms).length > 0
      && !accommodationVouchers[0].isVilla
    ) {
      setRoomSummary(true);
    }
    if (
      accommodationVouchers
      && accommodationVouchers[0]
      && accommodationVouchers[0].accommodationDetails.title
      && accommodationVouchers[0].accommodationDetails.title.length > 0
    ) {
      setAccommodationDetails(true);
      setVoucherDownload(true);
    }
    if (transport && transport.tickets.inbound) {
      setTransportDetails(true);
    }
    if (
      accommodationVouchers
      && accommodationVouchers.length > 0
      && accommodationVouchers[0].tickets
      && Object.keys(accommodationVouchers[0].tickets).length > 0
    ) {
      setAccommodationTickets(true);
    }
    if (
      accommodationVouchers
      && accommodationVouchers.length > 0
      && accommodationVouchers[0].tickets
      && Object.keys(accommodationVouchers[0].tickets).length > 0
    ) {
      setAccommodationTickets(true);
    }
  }, [accommodationVouchers]);

  return (
    <div id={tabID} className={styles.travelDocuments}>
      {transportDetails && <TransportDetails transport={transport} />}
      {accommodationDetails && (
        <AccommodationDetails
          details={accommodationVouchers[0].accommodationDetails}
          transport={transport}
          isParisPackage={isParisPackage}
          isVilla={accommodationVouchers[0].isVilla}
        />
      )}
      {roomSummary && <RoomDetails details={accommodationVouchers[0].accommodationDetails} />}
      {voucherDownload && (
        <VoucherDownload
          vouchers={accommodationVouchers[0].vouchers}
          bookingCanceled={accommodationVouchers[0].bookingCanceled}
          orderStatus={orderStatus}
          orderId={orderId}
          productName={accommodationVouchers[0].accommodationDetails.title}
          balance={balance}
        />
      )}
      {accommodationTickets && (
        <AccommodationTickets tickets={accommodationVouchers[0]} orderId={orderId} balance={balance} />
      )}
      {recommedations && (
        <button
          type="button"
          className={styles.addMagic}
          onClick={onSwitchToRecommendations}
        >
          Add a Little Magic -&gt;
        </button>
      )}
    </div>
  );
}

export default TravelDocuments;
